import { Component, OnInit } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { CalendarOptions, DateSelectArg } from '@fullcalendar/core';
import { CalendarService } from '../../core/services/calendar.service'
import { MatStepper } from '@angular/material/stepper';
import { UserService } from 'src/app/core/services/user.service';
import { AuthService } from 'src/app/core/services/auth.service';
import { MatDialogRef } from '@angular/material/dialog';
import * as moment from 'moment';
import { BookingsService } from 'src/app/core/services/bookings.service';
import { Booking } from 'src/app/core/models/booking.model';
@Component({
  selector: 'app-availability-calendar',
  templateUrl: './availability-calendar.component.html',
  styleUrls: ['./availability-calendar.component.sass']
})
export class AvailabilityCalendarComponent implements OnInit {
  selectedDates: DateSelectArg[];
  calendarOptions: CalendarOptions = {
    headerToolbar: {},
    initialView: 'dayGridMonth',
    weekends: true,
    editable: true,
    selectable: true,
    selectMirror: true,
    dayMaxEvents: true,
    select: this.handleDateSelect.bind(this),
  };
  startTime = { hour: 13, minute: 30 };
  endTime = { hour: 14, minute: 30 };

  constructor(public calendarService: CalendarService, public userService: UserService, public authService: AuthService, private bookingsService: BookingsService,
    public dialogRef: MatDialogRef<AvailabilityCalendarComponent>) { this.selectedDates = []; }



  handleDateSelect(date: DateSelectArg) {
    this.selectedDates.push(date);
  }

  removeDate(date: DateSelectArg) {
    const tempArr = [];
    for (let i = 0; i < this.selectedDates.length; i++) {
      if (this.selectedDates[i].endStr !== date.endStr) {
        tempArr.push(this.selectedDates[i]);
      }
    }
    this.selectedDates = [];
    this.selectedDates = tempArr;
  }
  goBack(stepper: MatStepper) {
    stepper.previous();
  }

  goForward(stepper: MatStepper, type: string) {
    stepper.next();
  }
  async saveDateTime() {
    const bookings = [];
    const user = this.authService.currentUserObj;
    for (let i = 0; i < this.selectedDates.length; i++) {

      const date = this.selectedDates[i].start;
      const start = moment(date);
      start.hours(this.startTime.hour);
      start.minutes(this.startTime.minute);
      const end = start.clone();
      end.hours(this.endTime.hour);
      end.minutes(this.endTime.minute);
      const diff = end.diff(start, 'hours');
      const booking = new Booking();
      booking.instructorId = user.userId;
      booking.startDateTime = start.toDate();
      booking.dateStr = start.format('yyyy-MM-DD');
      bookings.push(booking);
      let tempDate = start.clone();
      for (let j = 0; j < diff; j++) {
        const newDate = tempDate.add(1, 'hours');
        const booking = new Booking();
        booking.instructorId = user.userId;
        booking.startDateTime = newDate.toDate();
        booking.dateStr = newDate.format('yyyy-MM-DD');
        bookings.push(booking);
        tempDate = newDate.clone();
      }
    }

    await this.bookingsService.insertAvailbleDates(bookings);
    this.dialogRef.close();
  }
  ngOnInit(): void {
  }

}
